export default __webpack_public_path__ + "static/media/polele.2af3c8c7.svg";